import React from "react";
import { PageBuilderCustomOfferBoxFragment } from "types/graphql-types";
import { graphql } from "gatsby";
import { matchesAny } from "src/utils/localization/geolocation";
import {
  SectionContainer,
  SectionTitleBody,
  SectionTitleHeading
} from "@silversea-ssc/ui-components-react";
import { getCurrentOppositeColor } from "./componentBackgroundHelper";
import { ComponentBackgroundColor } from "types/componentBackground";
import { useGeolocation } from "src/utils/localization/geolocation/GeolocationContext";
import { SectionTitle } from "@silversea-ssc/ui-components-react";
import OfferHighlights, {
  OfferHighlight
} from "components/OfferHighlights/OfferHighlights";
import TextBox from "components/TextBox/TextBox";
import { isPresent } from "src/utils/checks";

export const PageBuilderCustomOfferBoxSectionContainer: React.FC<{
  backgroundColor: ComponentBackgroundColor;
  section: PageBuilderCustomOfferBoxFragment;
}> = ({ backgroundColor, section }) => {
  const geoLocation = useGeolocation();
  const visible = matchesAny(section.locationFilters, geoLocation.countryCode);
  if (!visible) return null;

  return (
    <SectionContainer
      spacingTop="compact"
      spacingBottom="compact"
      backgroundColor={backgroundColor}
      dataContentName="AccordionText_section"
    >
      <PageBuilderCustomOfferBox
        {...section}
        cardBackgroundColor={getCurrentOppositeColor()}
      />
    </SectionContainer>
  );
};

export interface PageBuilderCustomOfferBoxProps
  extends PageBuilderCustomOfferBoxFragment {
  cardBackgroundColor?: ComponentBackgroundColor;
}

const PageBuilderCustomOfferBox: React.FC<PageBuilderCustomOfferBoxProps> = ({
  title,
  subtitle,
  disclaimer,
  items,
  cardBackgroundColor
}) => {
  const offers: OfferHighlight[] = (
    items?.filter(isPresent) || []
  ).map<OfferHighlight>((i) => ({
    name: i.title?.localized || "",
    description: i.text?.localized,
    icon: i.icon
  }));

  return (
    <React.Fragment>
      <SectionTitle variant="wide">
        <SectionTitleHeading tagline={subtitle?.localized}>
          {title?.localized}
        </SectionTitleHeading>
        <SectionTitleBody>
          <OfferHighlights
            variant="large"
            offers={offers}
            title={undefined}
            tokenValues={{}}
            cardBackgroundColor={cardBackgroundColor}
          />
          {disclaimer?.localized && (
            <React.Fragment>
              <br />
              <TextBox
                content={disclaimer?.localized}
                fontSize="disclaimer"
                textAlign="left"
              />
            </React.Fragment>
          )}
        </SectionTitleBody>
      </SectionTitle>
    </React.Fragment>
  );
};

export default PageBuilderCustomOfferBox;

export const fragments = graphql`
  fragment PageBuilderCustomOfferBoxItem on SanityCustomOfferBoxItem {
    _key
    icon
    title {
      localized
    }
    text {
      localized
    }
  }
  fragment PageBuilderCustomOfferBox on SanityCustomOfferBox {
    _key
    title {
      localized
    }
    subtitle {
      localized
    }
    disclaimer {
      localized
    }
    locationFilters {
      ...LocationFilter
    }
    items {
      ...PageBuilderCustomOfferBoxItem
    }
  }
`;
